<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Pre-engagement Questionnaire</h1>
    <p>Thank you for completing your pre-onboarding tasks.</p>
    <p>We'd like to find out a little more about your payroll requirements, to ensure that we tailor our service to your needs.</p>
    <p>We have prepared a Questionnaire, to identify the areas that may need further information.</p>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>